import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HorizontalLayout from "components/HorizontalLayout";

//constants
const Authmiddleware = (props) => {

  const Layout = HorizontalLayout;

  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>);
};

export default Authmiddleware;
